<template>
    <div>
        <div class="dropdown-menu crm-header-panel dropdown-notifications-holder" v-el:dropdown v-if="visible" transition="crm-header-fade" :style="getStyle()">
            <div class="notification-header"><span>Notificações</span><i class="fa fa-bell-o" aria-hidden="true"></i></div>
            <div v-if="!hasNotifications" class="crm-panel-empty">
                Não há notificações.
            </div>
            <div v-slimscroll :height="400" :always="false" v-if="hasNotifications">
                <ul class="dropdown-notifications">
                    <li v-for="notification in notifications">
                        <div>
                            <a :href="notification.button && notification.button.url" class="notification-holder" @click="buttonClicked($event, notification.button)">
                                <span class="crm-notification-icon" aria-hidden="true"><i class="fa fa-bell-o"></i></span>
                                <div class="notification-subject">
                                    {{ notification.subject }}
                                </div>
                                <div class="notification-content">
                                    {{{ notification.content }}}
                                </div>

                                <div class="notification-footer text-muted" style="display: flex">
                                    <div style="width: 100%; flex-grow: 1; flex-shrink: 1">
                                        Origem: <b>{{notification.textSources}}</b>
                                    </div>
                                    <div style="text-align: right; width: 100%" :title="notification.createdAt | datetime_with_year">
                                        {{ notification.createdAt | timeago }}
                                    </div>
                                </div>
                            </a>
                            <div class="notification-buttons">
                                <a v-for="button in notification.buttons" :href="button.url" @click="buttonClicked($event, button)">
                                    {{ button.name }}
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <property-info-handler v-ref:property-info></property-info-handler>
        <button class="btn default quick-view-customer btn-xs"
                v-quick-view-customer
                v-bind:data-id="ui.currentCustomerId"
                v-bind:data-root="'/customers/'"
                title="Visualizar"
                style="position: relative;z-index:2;border-bottom-right-radius:3px;border-top-right-radius:3px;display: none"
                v-el:view-customer-button>
            <i class="fa fa-eye"></i>
        </button>
    </div>
</template>

<script>
    const { notificationsClient } = require('sci/helpers')
    const utils = require('sci/utils')
    const moment = require('moment')
    const notificationsSub = require('sci/subscriptions/notifications')

    export default {
        name: 'NavbarDropdownPopup',
        props: {
            visibilityChanged: {
                type: Function
            },
            hasNewChanged: {
                type: Function
            }
        },
        init () {
            this.$newEl = null;
            this.$subscription = null;
        },
        data: () => ({
            loading: true,
            notifications: [],
            visible: false,
            top: 0,
            right: 0,
            ui: {
                currentCustomerId: null
            },
            lastOpen: null
        }),
        destroyed () {
            this.destroyEvent()
            document.body.removeChild(this.$newEl)

            if (this.$subscription) {
                this.$subscription.unsubscribe()
            }
        },
        ready () {
            this.lastOpen = localStorage.getItem("notifications:last-open") || null

            if (!this.lastOpen) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("notifications:last-open", this.lastOpen)
            }

            this.$newEl = this.$appendTo(document.body).$el

            this.load()

            this.$subscription = notificationsSub.subscribe(this.load)
        },
        methods: {
            load (_e, _f) {
                notificationsClient.query({
                    query: `
                        query {
                          listNotifications {
                            type
                            subject
                            content
                            meta
                            createdAt
                            sources {
                              __typename
                              id
                              type
                              ... on Notification_Source_Website { website { uid } }
                              ... on Notification_Source_Portal { portal { name } }
                            }
                            resources {
                              __typename
                              id
                              type
                              urn
                              path
                              isValid
                              ... on Notification_Resource_Form {
                                formId
                              }
                              ... on Notification_Resource_Customer {
                                customerId
                              }
                              ... on Notification_Resource_Property {
                                propertyId
                              }
                            }
                          }
                        }
                    `
                }).then((res) => {
                    this.notifications = res.data.listNotifications.map((n) => {
                        n.sources = n.sources.map((s) => {
                            switch (s.type) {
                                case 'WEBSITE':
                                    s.name = 'Website'
                                    break;
                                case 'PORTAL':
                                    s.name = 'Portal'
                                    if (s.portal) {
                                        s.name = `${s.name}: ${s.portal.name}`
                                    }
                                    break;
                                case 'EMAIL':
                                    s.name = 'E-mail'
                                    break;
                            }

                            return s
                        }).filter(_ => !!_.name)
                        n.buttons = n.resources.map((r) => {
                            let name = null
                            let url = null
                            let isExplicitLink = true

                            switch (r.type) {
                                case 'PROPERTY':
                                    name = 'Ver Imóvel'
                                    url = '/properties/' + r.propertyId
                                    isExplicitLink = false
                                    break;
                                case 'FORM':
                                    name = 'Ver Negócio'
                                    url = '/forms/' + r.formId
                                    isExplicitLink = true
                                    break;
                                case 'CUSTOMER':
                                    name = 'Ver Cliente'
                                    url = '/customers/' + r.customerId
                                    isExplicitLink = false
                                    break;
                            }

                            return {
                                ...r,
                                name,
                                url,
                                isExplicitLink
                            }
                        }).filter(_ => !!_.name)

                        n.button = n.buttons[0]
                        n.textSources = n.sources.map(_ => _.name).join(', ')

                        return n
                    })

                    if (this.lastOpen) {
                        const hasNew = this.notifications.filter(e => e.createdAt > this.lastOpen)
                        this.hasNewChanged && this.hasNewChanged(hasNew.length)
                    }
                })
            },
            buttonClicked (evt, button) {
                if (!button) {
                    evt.preventDefault()
                    return false;
                }

                if (button.isExplicitLink || evt.ctrlKey || evt.metaKey) {
                    return true
                }

                evt.preventDefault()

                switch (button.type) {
                    case 'PROPERTY':
                        this.$refs.propertyInfo.showById(button.propertyId)
                        break;
                    case 'CUSTOMER':
                        this.ui.currentCustomerId = button.customerId
                        setTimeout(() => {
                            this.$els.viewCustomerButton.click()
                        }, 100)
                        break;
                }

                return false
            },
            move (anchor) {
                this.$anchor = anchor

                const rect = anchor.getBoundingClientRect()
                const viewportWidth = document.documentElement.clientWidth
                const panelWidth = Math.min(360, viewportWidth - 16)

                this.top = rect.bottom + window.scrollY + 8
                this.right = Math.max(8, Math.min(viewportWidth - rect.right, viewportWidth - panelWidth - 8))
            },
            toggle (anchor) {
                if (this.visible) {
                    this.hide()
                } else {
                    this.show(anchor)
                }
            },
            show (anchor) {
                this.lastOpen = moment().utc().format("YYYY-MM-DD HH:mm:ss")
                localStorage.setItem("notifications:last-open", this.lastOpen)

                this.hasNewChanged && this.hasNewChanged(false)

                this.move(anchor)
                this.visible = true


                this.createEvent()
            },
            hide () {
                this.visible = false

                this.destroyEvent()
            },
            createEvent () {
                this.destroyEvent()
                document.documentElement.addEventListener('click', this.bodyClicked)
                window.addEventListener('scroll', this.bodyScrolled, true)
                window.addEventListener('resize', this.bodyScrolled)
            },
            destroyEvent () {
                document.documentElement.removeEventListener('click', this.bodyClicked)
                window.removeEventListener('scroll', this.bodyScrolled, true)
                window.removeEventListener('resize', this.bodyScrolled)
            },
            bodyScrolled (e) {
                if (!utils.isElementInViewport(this.$anchor)) {
                    this.hide()
                } else {
                    this.move(this.$anchor)
                }
            },
            bodyClicked (e) {
                const parent = this.$parent

                if (parent.constructor.name === 'NavbarNotifications') {
                    if (!parent.$el.contains(e.target) && !this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                } else {
                    if (!this.$els.dropdown.contains(e.target)) {
                        this.hide()
                    }
                }
            },
            getStyle () {
                const style = {}

                style.top = this.top + 'px'
                style.right = this.right + 'px'

                // if (this.position === 'right') {
                //     style.right = 0
                //     style.left = 'auto'
                // } else {
                //     style.top = this.top
                //     style.left = this.left
                // }

                style.width = '360px'
                style.maxWidth = 'calc(100vw - 16px)'
                style.display = 'block'

                return style
            },
        },
        computed: {
            hasNotifications () {
                return this.notifications.length > 0
            }
        },
        watch: {
            visible (newVal) {
                this.visibilityChanged(newVal)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Dropdown.vue?d84b85f6